import React, { useEffect, useState } from 'react';
import { useGate, useStore } from 'effector-react';
import useConstant from 'use-constant';
import { $loadedScene } from '@stores/loadedStore';
import { getAudioLengthByUrl } from '@utils/getAudioLength';
import {
  $GateRotateAudioLength,
  $rotateCurrentLeft,
  $rotateIsPlaying,
} from '@stores/autoRotateStores';
import { $audioPlayer } from '@stores/audioPlayerStores';
import WaveView from '../../../VirtualHumanApp/WaveView';
import { getRotateMediaUrl } from '../utils/rotateHelpers';
import { PX_PER_SEC } from '../constants';

interface Props {
  width: number;
}
export function RotateAudio({ width }: Props) {
  const scene = useStore($loadedScene)!;
  const [waveLength, setWaveLength] = useState(0);
  const { url, type } = getRotateMediaUrl(scene);
  useEffect(() => {
    setWaveLength(0);
    if (url) {
      getAudioLengthByUrl(url).then(setWaveLength);
    }
  }, [url]);
  useGate($GateRotateAudioLength, waveLength);
  const audio = useConstant(() => new Audio());
  const curTime = useStore($rotateCurrentLeft) / PX_PER_SEC;
  const isPlaying = useStore($rotateIsPlaying);

  useEffect(() => {
    return () => {
      audio?.pause();
    };
  }, []);

  const isOn = isPlaying && curTime <= waveLength;

  useEffect(() => {
    if (type !== 'audio' || !url) return;
    audio.src = url;
    if (isOn) {
      $audioPlayer.stopAudio();
      audio.currentTime = curTime;
      audio.play();
    } else {
      audio.pause();
      audio.currentTime = 0;
    }
  }, [isOn, url, type]);

  return (
    <div
      className="relative mt-10 flex h-40 items-center bg-black-#34"
      style={{ width }}
    >
      {url ? (
        !!waveLength && (
          <>
            <WaveView
              key={url}
              audioUrl={url}
              width={waveLength * PX_PER_SEC}
              height={40}
            />
            <div
              className="absolute left-5 rounded bg-black-black bg-opacity-50 p-5"
              style={{ fontSize: 10 }}
            >
              {`${waveLength}s`}
            </div>
          </>
        )
      ) : (
        <div className="pl-10 text-black-gray">
          添加已制作好的“AI讲解”内容，有针对性的设置导览节点。
        </div>
      )}
    </div>
  );
}
